<template>
<div class="chapter">
<div class="inner_page">
<div id="eBook4242-1.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="Title" id="toc_marker-2"><span class="char-style-override-1">S</span><span class="char-style-override-2">INGING</span><span class="char-style-override-1"><br/></span><span class="char-style-override-2">AT THE </span><span class="char-style-override-1">G</span><span class="char-style-override-2">ATES</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42421.vue?9e3c839a